export const formattedLongText = (message, limit) => {
  if (!message) return '';

  const isLong = message.length > limit;

  return isLong ? `${message.slice(0, limit)}...` : message;
};
